import { render } from "./ReportAgingInvoice.vue?vue&type=template&id=3ff10b24&scoped=true"
import script from "./ReportAgingInvoice.vue?vue&type=script&lang=js"
export * from "./ReportAgingInvoice.vue?vue&type=script&lang=js"

import "./ReportAgingInvoice.vue?vue&type=style&index=0&id=3ff10b24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ff10b24"]])

export default __exports__